/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const routes = App();

ReactDOM.render(
    routes, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js